
import React from "react";
import "./_dialogModal.scss";
import trimbleLogo from "../../utils/images/trimble-logo.svg";
import { FormattedMessage } from "react-intl";

const DialogModalHeader = (props) => {
     let hide_cancel = props.hide_cancel;
     return (
    <div className="line-break">
         <div className="cancel-popup">
         {!hide_cancel &&
         <a href="" onClick={(e) => props.handleClose(e)}>
             &lt;{" "}
             <span>
               <FormattedMessage defaultMessage="Cancel" />
             </span>
           </a>}
         </div>
         <img src={trimbleLogo} className="trimble-logo" alt="trimbel_logo" />
         <div className="account-switch-title">
           {props.title}
         </div>
       </div>
     );
   };

export default DialogModalHeader;